/* ⚛ REACT */
import React, { useEffect } from "react";

/* 📦 LIBS */
import { useLocation } from "react-router-dom";
import { useTour } from "@reactour/tour";

/* 🧩 COMPONENTS */
import { Button, CloseIcon } from "../../Components";

/* 🧠 REDUX */
import { store } from "../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeModal } from "../../Redux/Actions";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContentContainer, ChildsContainer } from "./styles";

/* 🔧 UTILS */
import { isValidaProp } from "../../util/validate";

const Modal = (props) => {

    const { isOpen, currentStep } = useTour();

    let childs = React.Children.toArray(props.children);
    let active = useSelector(state => state.ModalReducer.name) === props.name;
    const height = isValidaProp(props.height) ? props.height : '50%';
    const width = isValidaProp(props.width) ? props.width : '50%';

    const location = useLocation();

    const isCloseDisabled = isOpen && (currentStep === 1 || currentStep === 3);

    const handleCloseModal = () => {
        if (isCloseDisabled) return;
        store.dispatch(changeModal(null));
    };

    useEffect(() => {
        store.dispatch(changeModal(null));
    }, [location]);

    return(
        <>
            <Container $Active={active} onClick={handleCloseModal}>
                <ContentContainer $width={width} $height={height} id={props.id} onClick={(event) => event.stopPropagation()}>
                    <Button 
                    color={"white-green"} 
                    onClick={handleCloseModal} 
                    icon={<CloseIcon fill={"#333"} />} 
                    padding={"0"} 
                    position={"absolute"} 
                    radius={"50%"} 
                    height={"44px"} 
                    width={"44px"}
                    disabled={isCloseDisabled}/>

                    {props.title &&
                        <TitleContainer>
                            <Title>{props.title}</Title>
                        </TitleContainer>
                    }
                    <ChildsContainer>
                        {childs.map(child => (
                            child
                        ))}
                    </ChildsContainer>
                </ContentContainer>
            </Container>
        </>
    )
}

export default Modal;